import { createApiClient } from './apiClient'
import {
  Allergen,
  AllergenPayload,
  FoodGroup,
  FoodGroupPayload,
  Season,
  SeasonPayload,
  Unit,
  UnitPayload,
  Ingredient,
  IngredientPayload,
  PaginatedResponse,
} from '../types/catalog'

function service(token: string | null) {
  const api = createApiClient(token)

  return {
    // ── Allergens ────────────────────────────────────────
    allergens: {
      list: (page: number, perPage: number) =>
        api.get<PaginatedResponse<Allergen>>(`/api/allergens?page=${page}&perPage=${perPage}`),
      create: (data: AllergenPayload) => api.post<Allergen>('/api/allergens', data),
      update: (id: string, data: AllergenPayload) =>
        api.put<Allergen>(`/api/allergens/${id}`, data),
      delete: (id: string) => api.delete<void>(`/api/allergens/${id}`),
    },

    // ── Food Groups ──────────────────────────────────────
    foodGroups: {
      list: (page: number, perPage: number) =>
        api.get<PaginatedResponse<FoodGroup>>(`/api/food-groups?page=${page}&perPage=${perPage}`),
      create: (data: FoodGroupPayload) => api.post<FoodGroup>('/api/food-groups', data),
      update: (id: string, data: FoodGroupPayload) =>
        api.put<FoodGroup>(`/api/food-groups/${id}`, data),
      delete: (id: string) => api.delete<void>(`/api/food-groups/${id}`),
    },

    // ── Seasons ──────────────────────────────────────────
    seasons: {
      list: (page: number, perPage: number) =>
        api.get<PaginatedResponse<Season>>(`/api/seasons?page=${page}&perPage=${perPage}`),
      create: (data: SeasonPayload) => api.post<Season>('/api/seasons', data),
      update: (id: string, data: SeasonPayload) => api.put<Season>(`/api/seasons/${id}`, data),
      delete: (id: string) => api.delete<void>(`/api/seasons/${id}`),
    },

    // ── Units ────────────────────────────────────────────
    units: {
      list: (page: number, perPage: number) =>
        api.get<PaginatedResponse<Unit>>(`/api/units?page=${page}&perPage=${perPage}`),
      create: (data: UnitPayload) => api.post<Unit>('/api/units', data),
      update: (id: string, data: UnitPayload) => api.put<Unit>(`/api/units/${id}`, data),
      delete: (id: string) => api.delete<void>(`/api/units/${id}`),
    },

    // ── Ingredients ──────────────────────────────────────
    ingredients: {
      list: (page: number, perPage: number) =>
        api.get<PaginatedResponse<Ingredient>>(`/api/ingredients?page=${page}&perPage=${perPage}`),
      create: (data: IngredientPayload) => api.post<Ingredient>('/api/ingredients', data),
      update: (id: string, data: IngredientPayload) =>
        api.put<Ingredient>(`/api/ingredients/${id}`, data),
      delete: (id: string) => api.delete<void>(`/api/ingredients/${id}`),
    },
  }
}

export default service
